import React, { useState, ChangeEvent, FormEvent, useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { startUpload, uploadSuccess, uploadFailure } from '../../store/imageSlice';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchUserData } from '../../store/UserSlice';

interface PopupContentProps {
  closePopups: () => void;
}

const PopupContent: React.FC<PopupContentProps> = ({closePopups}) => {
  const dispatch = useDispatch<any>();
  const [title, setTitle] = useState('');
  const [image, setImage] = useState<File | null>(null);  
  const [someState, setSomeState] = useState('');
  const [selectedImage, setSelectedImage] = useState<File | null>(null);


  const [error, setError] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  

  const handleTitleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setTitle(e.target.value);
  };

  const handleImageChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedImage(file);
    }
    // Validate file type
    if (file && file.type.includes('image')) {
      // Set the selected image for preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(file);
      };
      reader.readAsDataURL(file);

      // Set the selected image file
      setImage(file);
      setError(null);
    } else {
      // Handle invalid file type
      setSelectedImage(null);
      setImage(null);
      setError('Please upload a valid image file.');
    }
  };
  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
  
    // Dispatch startUpload action
    dispatch(startUpload());
  
    try {
      const formData = new FormData();
     
      if (selectedImage) {
        formData.append('icon', selectedImage);
        formData.append('name', title);
      } else {
        // Handle the case where selectedImage is null
        // For example, show an error message or take appropriate action
        return;
      }
      
      const storedData = localStorage.getItem('loginData');
      if (!storedData) {
        // Handle the case where the stored data is null or undefined
        console.error('Stored data is null or undefined.');
        dispatch(uploadFailure('Stored data is null or undefined.'));
        return;
      }

      const parsedData = JSON.parse(storedData);

      // Access the access token property
      const accessToken = parsedData?.accessToken;

      if (accessToken) {
        const response = await axios.post(
          'http://ec2-3-73-128-99.eu-central-1.compute.amazonaws.com/api/v1/healthConditions',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ${accessToken}`,
              // Add other headers if needed
            },
          }
        );
      // Dispatch uploadSuccess action
      dispatch(uploadSuccess(response.data.imageUrl));

      // toast.success("Sucessfully Created.");
      setSomeState('someValue');
    } else {
      // Handle the case where the access token is not available
      // For example, show an error message or take appropriate action
      console.error('Access token is not available.');
      dispatch(uploadFailure('Access token is not available.'));
    }
  } catch (error: any) {
    // Dispatch uploadFailure action
    toast.error(error.response?.data?.message)
    // setError(error.response?.data?.message || 'An error occurred.');
  }
};

useEffect(() => {
  // Check if someState has changed and then dispatch fetchUserData
  if (someState === 'someValue') {
    dispatch(fetchUserData()).then(()=> {
      closePopups();
      toast.success("Sucessfully Added.");
    });
  }

}, [dispatch, someState]);
  return (
    <div className="max-w-md mt-2 m-auto p-4 md:p-8 bg-white rounded ">
      <h2 className="text-xl md:text-2xl flex font-gilroy mb-6 font-bold  text-[#263238]">
        <img src='./images/round_icon.png' alt="condition" className='object-contain pr-2'/>
        Add New Condition
      </h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-[#607D8B] text-sm mb-2 font-gilroy" htmlFor="image">
            Add Icon
          </label>
          <div className="flex items-center  w-full">
          <label className={`flex flex-col items-center  w-32 h-30 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50  hover:bg-gray-100 ${selectedImage instanceof File ? "hidden" : ""}`}>
              <div className="flex flex-col items-center justify-center pt-5 pb-6 " >
                <img src='./images/gallery-add.png' alt="upload"  />
                <p className="text-xs text-[#4C535F] mt-4 font-gilroy">Upload Icon</p>
              </div>
              <input
                    id="image"
                    type="file"
                    name="image"
                    onChange={handleImageChange}
                    className={"visually-hidden"} // Corrected syntax
                    accept="image/*"
                    required  
                    ref={fileInputRef}
                  />  

            </label>
            {selectedImage instanceof File && (
              <img src={URL.createObjectURL(selectedImage)} alt="preview" className="w-auto max-w-md pl-2 h-32 object-contain" />
            )}

            {error && <p style={{ color: 'red' }}>{error}</p>}
          </div>
        </div>

        <div className="mb-6 mt-4">
          <label className="block text-[#607D8B] text-sm mb-2  font-gilroy" htmlFor="title">
            Health Conditions
          </label>
          <input
            type="text"
            id="title"
            name="title"
            value={title}
            onChange={handleTitleChange}
            className="w-full  font-gilroy px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 bg-[#F5F7F8]"
            placeholder="Enter title"
            required
          />
        </div>    
        <button
          type="submit"
          className="bg-[#B4804A] font-gilroy w-full text-white py-2 px-4 font-semibold rounded-md"
        >
          Add New Condition
        </button>
      </form>
    </div>
  );
};

export default PopupContent;
